export enum TriggerReportReason {
  ALL = "ALL",
  QUARANTINE = "QUARANTINE",
  BLOCKLIST = "BLOCKLIST",
  ENGAGEMENT = "ENGAGEMENT",
  RESPONSE = "RESPONSE",
  SEND_ERROR = "SEND_ERROR",
  PROCESSED_STATUS = "PROCESSED_STATUS"
}

export enum TriggerReportApp {
  ABANDONED_CART = "carrinho_abandonado",
  REPIQUE_CAMPAIGN = "campanha_repique",
}
